import { isStaEnv } from "@ui/constants/env";

export enum ChainName {
  MONAD = 'Monad',
  MONAD_TESTNET = 'Monad Testnet',
}

export enum ChainType {
  TestNet,
  MainNet,
}

export enum ChainId {
  MONAD_TESTNET = 10143,
  MONAD_MAINNET = 143,
}

export const CHAIN_NAMES = [ChainName.MONAD_TESTNET, ChainName.MONAD];